import {
  _increment,
  production_type,
  job_no,
  unit,
  heat_treatment,
  surface_treatment,
} from '@/table/Job/SubJob/base';
import useSubJob from '@/use/useSubJob';

const {
  translateSubJobStatus, statusClassMap,
} = useSubJob();

function getStatus(
  overallStatus: string,
  computedStatus: string,
  processStatus: string | null = null,
  assemblyStatus: string | null = null,
) {
  if (assemblyStatus === 'DONE') return 'DONE';
  if (assemblyStatus === 'FAILED_ASSEMBLY') return 'FAILED_ASSEMBLY';
  if (overallStatus === 'ASSEMBLY') return 'ASSEMBLY';
  if (overallStatus === 'REVISE' || overallStatus === 'MODIFY') return overallStatus;
  return computedStatus;
}

export default {
  types: {
    _increment,
    production_type,
    job_no: {
      ...job_no,
      width: '1fr',
    },
    currentStatusAmount: {
      name: 'ทั้งหมด / ปัจจุบัน',
      width: '8rem',
      class: 'text-center',
    },
    addonAmount: {
      name: 'จำนวนเพิ่มเติม',
      width: '6rem',
      class: 'text-center',
    },
    unit,
    status: {
      name: 'สถานะปัจจุบัน',
      width: '8rem',
      filter: (val: string, row: any) => translateSubJobStatus(getStatus(row.item.status, row.item.computed_status, row.item.process_status, row.item.assembly_status)),
      class: {
        text: (val: string, row: any) => statusClassMap(getStatus(row.item.status, row.item.computed_status, row.item.process_status, row.item.assembly_status)),
      },
    },
  },
};
